import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tl_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    const url = orig?.url || "";
    if (err.response?.status === 401 && !orig._retry && !url.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        localStorage.setItem("tl_token", data.access_token);
        return api(orig);
      } catch (e) {
        localStorage.removeItem("tl_token");
      } finally {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fmt = (v, dp = 2) => (v === null || v === undefined || Number.isNaN(v) ? "-" : Number(v).toLocaleString("en-GB", { minimumFractionDigits: dp, maximumFractionDigits: dp }));
let CUR = "£";
const SYM = { GBP: "£", USD: "$", EUR: "€" };
export const setCurrency = (code) => { CUR = code ? SYM[code] || `${code} ` : "£"; return CUR; };
export const cur = () => CUR;
export const cc = (s) => (typeof s === "string" ? s.replaceAll("£", CUR) : s);
export const gbp = (v) => (v === null || v === undefined ? "-" : `${v < 0 ? "-" : ""}${CUR}${fmt(Math.abs(v))}`);
export const pnlClass = (v) => (v > 0 ? "text-emerald-400" : v < 0 ? "text-rose-400" : "text-slate-300");
export const ldnTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { timeZone: "Europe/London", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-");
